export { default as default } from './KitImage';
